export { Mascots } from './background'
